import { jsx as _jsx } from "react/jsx-runtime";
import { useCallback, useLayoutEffect, useState } from 'react';
import { Router } from 'react-router';
import sendAnalyticsData from '../functions/sendAnalyticsData';
import { useMount } from 'react-use';
import { v4 as uuid } from 'uuid';
export function AnalyticsRouter(_a) {
    var basename = _a.basename, children = _a.children, window = _a.window, history = _a.history;
    var _b = useState({
        action: history.action,
        location: history.location,
    }), state = _b[0], setState = _b[1];
    var sessionId = useState(uuid())[0];
    var sendAnalytics = useCallback(function (history) {
        sendAnalyticsData({
            sessionId: sessionId,
            source: window.location.hostname,
            path: history.location.pathname,
            type: 'page-view',
            message: '',
        });
    }, [sessionId, window]);
    useMount(function () {
        sendAnalytics(history);
    });
    var listener = useCallback(function (history) {
        setState(history);
        if (process.env.NODE_ENV === 'development')
            return;
        sendAnalytics(history);
    }, [setState, sendAnalytics]);
    useLayoutEffect(function () { return history.listen(listener); }, [history, listener]);
    return (_jsx(Router, { basename: basename, children: children, location: state.location, navigationType: state.action, navigator: history }));
}
export default AnalyticsRouter;
